/**
 * Baytları birebir kod birimlerine eşler (ISO-8859-1 kimliği): bayt 0xNN → U+00NN.
 * MIME gövdesini metin gibi tarayıp sonra `charCodeAt(0) & 0xff` ile bayta dönmek
 * yalnızca bu eşleme kayıpsızsa doğrudur.
 *
 * `new TextDecoder('latin1')` KULLANILMAZ: Encoding standardında "latin1" etiketi
 * ISO-8859-1'e değil windows-1252'ye çözülür ve 0x80-0x9F baytlarını başka kod
 * noktalarına taşır (0x9F → U+0178). Bayta geri dönüldüğünde 0x9F yerine 0x78 ('x')
 * çıkar; UTF-8 gövdede "ğ Ğ ş Ş Ç Ö Ü" harfleri bozulur. Node bu etiketi birebir
 * çözdüğü için hata yalnızca tarayıcıda görülür — vitest bunu yakalamaz,
 * e2e/mht-8bit.spec.ts yakalar.
 */
export function bytesToBinary(bytes: Uint8Array): string {
  // String.fromCharCode değişken sayıda argüman alır; büyük dosyalarda yığın taşmaması için parçalanır.
  const CHUNK = 0x8000;
  if (bytes.length <= CHUNK) return String.fromCharCode(...bytes);
  let out = '';
  for (let i = 0; i < bytes.length; i += CHUNK) out += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  return out;
}
